/** Segments the pages runtime serves itself (account, legal, coach, help). */
export const PAGE_UTILITY_SLUGS = [
  "account",
  "contact",
  "help",
  "privacy-policy",
  "terms-of-service",
];

/** Content follow-up views, opened from a page: `/article/:id` and so on. */
export const PAGE_CONTENT_SLUGS = ["article", "event", "video"];

/**
 * Addresses a page can't take: the runtime's own views win the route, so a
 * page there would be unreachable. `events` is only served where the project
 * has the events page, but it is refused everywhere so turning that on later
 * can't swallow a page.
 */
export const RESERVED_PAGE_SLUGS = [
  ...PAGE_UTILITY_SLUGS,
  ...PAGE_CONTENT_SLUGS,
  "events",
];

interface PagesDivisionLike {
  workspaceEnabled?: boolean;
  pagesEnabled?: boolean;
}

/** A non-workspace project that has pages enabled builds its own pages. */
export function hasProjectPages(division?: PagesDivisionLike | null): boolean {
  return !!division && !division.workspaceEnabled && !!division.pagesEnabled;
}

/**
 * The pages runtime replaces the classic dashboard at the project root: on a
 * workspace project with distributed pages, and on a project with its own.
 */
export function servesPages(division?: PagesDivisionLike | null): boolean {
  return !!division?.workspaceEnabled || !!division?.pagesEnabled;
}

export function reservedSlugMessage(slug: string): string {
  return `"/${slug}" is taken by the site itself. Choose another address.`;
}
